import React, { useEffect, useState } from 'react'
import '../../styles/dashboard.css';
import useAxiosPrivate from '../../api/useAxiosPrivate';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import { notify } from '../toast';

const EmployeeSubordinate = () => {

    const { id } = useParams();
    const { state } = useLocation();
    const navigate = useNavigate();

    const [activeIndex, setActiveIndex] = useState(0);
    const [employee, setEmployee] = useState({
        employeeId: '',
        name: '',
        mobile: '',
        email: '',
        parent: '',
        gender: '',
        address: '',
        educationQualification: '',
        aadhaar: '',
        bank: '',
        ifsc: '',
        pan: '',
        reportsTo: '',
        role: '',
    });
    const [holders, setHolders] = useState([]);
    const [totalHolders, setTotalHolders] = useState(1);
    const [subordinates, setSubordinates] = useState([]);
    const [totalSubordinates, setTotalSubordinates] = useState(1);

    const [pageLoading, setPageLoading] = useState(false);

    const axiosPrivate = useAxiosPrivate();

    const fetchEmployeeSubordinatesAndHolders = async (id, first = false) => {
        try {

            setPageLoading(true);

            const response = await axiosPrivate.get(`/employee/getSubordinateDirectSubordinatesAndHolders/${id}?page=${first ? 1 : Math.max(
                Math.ceil(holders.length / 10) + 1,
                Math.ceil(subordinates.length / 10) + 1
            )}`);

            const data = response?.data
            setSubordinates(prev => [...prev, ...data?.subordinatesDirectSubordinates]);
            setTotalSubordinates(data?.totalsubordinatesDirectSubordinates)
            setHolders(prev => [...prev, ...data?.holdersBySubordinate]);
            setTotalHolders(data?.totalHoldersBySubordinate);

        } catch (err) {
            notify('failed', err?.response?.data?.message);
        } finally {
            setPageLoading(false);
        }
    }

    const fetchEmployeeDetails = async (id) => {
        try {

            const response = await axiosPrivate.get(`/employee/getSubordinateDetails/${id}`);

            const data = response?.data
            setEmployee(data);
        } catch (err) {
            notify('failed', err?.response?.data?.message);
        }
    }

    useEffect(() => {
        fetchEmployeeDetails(id);
        fetchEmployeeSubordinatesAndHolders(id, true);

        return () => {
            setActiveIndex(0);
            setHolders([]);
            setTotalHolders(0);
            setSubordinates([]);
            setTotalSubordinates(0);
        }
        // eslint-disable-next-line
    }, [id]);

    return (
        <div className='container'>

            <div className='formRow employeeDetailsCard'>
                <div className='formGroup'>
                    <p><strong>ID : </strong>{employee.employeeId}</p>
                    <p><strong>Name : </strong>{employee.name}</p>
                    <p><strong>Mobile : </strong>{employee.mobile}</p>
                    <p><strong>Email : </strong>{employee.email}</p>
                    <p><strong>Parent : </strong>{employee.parent}</p>
                    <p><strong>Gender : </strong>{employee.gender}</p>
                    <p><strong>Reports to : </strong>{employee.reportsTo.name}</p>
                </div>
                <div className='formGroup'>
                    <p><strong>Address : </strong>{employee.address}</p>
                    <p><strong>Education qualification : </strong>{employee.educationQualification}</p>
                    <p><strong>Aadhaar : </strong>{employee.aadhaar}</p>
                    <p><strong>Bank account number : </strong>{employee.bank}</p>
                    <p><strong>IFSC : </strong>{employee.ifsc}</p>
                    <p><strong>pan : </strong>{employee.pan}</p>
                    <p><strong>Hierarchy : </strong>{employee.role}</p>
                </div>
            </div>

            <div className="inner">
                <div className="cards-container">

                    <div
                        className={`card ${activeIndex === 0 ? "active" : ""}`}
                        onClick={() => setActiveIndex(0)}>
                        <div className="card-body">
                            <h3 className="card-title">Holders</h3>
                            <h3 className="card-value">{totalHolders}</h3>
                        </div>
                    </div>

                    {employee.role !== 'village_cluster' ?
                        <div className={`card ${activeIndex === 1 ? "active" : ""}`}
                            onClick={() => setActiveIndex(1)}>
                            <div className="card-body">
                                <h3 className="card-title">Subordinates</h3>
                                <h3 className="card-value">{totalSubordinates}</h3>
                            </div>
                        </div>
                        :
                        <></>
                    }

                </div>
            </div>



            {// @ts-ignore
                activeIndex === 0 && holders?.length !== 0 &&
                <>

                    <h2 style={{ margin: '20px 0' }}>
                        Holders registered by <i style={{ color: 'var(--primary-text-color)' }}>{state?.name}</i>
                    </h2>

                    <section className="user-list">
                        <div className="list-header">
                            <span>Name</span>
                            <span>Mobile</span>
                            <span>Member count</span>
                        </div>

                        <div className="list-body">
                            {// @ts-ignore
                                holders.map((holder) => (
                                    <div className="list-row" key={holder?._id}>
                                        <span className='truncate' title={holder?.name} data-label="Name">{holder?.name}</span>
                                        <span className='truncate' title={holder?.mobile} data-label="Mobile">{holder?.mobile}</span>
                                        <span className='truncate' title={holder?.members?.length} data-label="Member count">{holder?.members?.length || 0}</span>
                                    </div>
                                ))
                            }
                        </div>

                    </section>


                    {totalHolders !== holders.length ?
                        <div>
                            <button className='add-btn' disabled={pageLoading} onClick={() => fetchEmployeeSubordinatesAndHolders(id)}>{pageLoading ? <span className='spinner' /> : 'Load more'}</button>
                        </div>
                        : <></>
                    }

                </>
            }

            {// @ts-ignore
                employee.role !== "village_cluster" && activeIndex === 1 && subordinates?.length !== 0 &&

                <>

                    <h2 style={{ margin: '20px 0' }}>
                        Direct subordinates of <i style={{ color: 'var(--primary-text-color)' }}>{state?.name}</i>
                    </h2>

                    <section className="user-list">
                        <div className="list-header">
                            <span>Id</span>
                            <span>Name</span>
                            <span>Gender</span>
                            <span>Mobile</span>
                            <span>Email</span>
                        </div>

                        <div className="list-body">
                            {// @ts-ignore
                                subordinates.map((subordinate) => (
                                    <div className="list-row employee-row"
                                        key={subordinate?._id}
                                        onClick={() => navigate(`/employee/${subordinate?._id}`, {
                                            state: {
                                                name: subordinate?.name
                                            }
                                        })}
                                    >
                                        <span className='truncate' title={subordinate?.employeeId} data-label="ID">{subordinate?.employeeId}</span>
                                        <span className='truncate' title={subordinate?.name} data-label="Name">{subordinate?.name}</span>
                                        <span className='truncate' title={subordinate?.gender} data-label="Gender">{subordinate?.gender}</span>
                                        <span className='truncate' title={subordinate?.mobile} data-label="Mobile">{subordinate?.mobile}</span>
                                        <span className='truncate' title={subordinate?.email} data-label="Email">{subordinate?.email}</span>
                                    </div>
                                ))
                            }
                        </div>

                    </section>

                    {(totalSubordinates !== subordinates.length) ?
                        <div>
                            <button className='add-btn' disabled={pageLoading} onClick={() => fetchEmployeeSubordinatesAndHolders(id)}>{pageLoading ? <span className='spinner' /> : 'Load more'}</button>
                        </div>
                        : <></>
                    }
                    <br />

                </>
            }

        </div>
    )
}

export default EmployeeSubordinate
